import { t } from "@/i18n-js/instance";
import { MemberCardWithConnection } from "@/react/components/shared/MembersList/CommunityMembers/CardView/MemberCardWithConnection";
import { useRecommendations } from "@/react/hooks/recommendations/useRecommendations";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

const i18nBase = "connections";

export const Recommendations = () => {
  const { data: recommendations } = useRecommendations();

  return (
    <div>
      {t(`${i18nBase}.recommendations`)}
      <ol
        className={classNames(
          "m-4 grid list-none auto-rows-fr grid-cols-[repeat(auto-fit,232px)] justify-center gap-6 md:m-0 lg:m-auto",
          /* Safari has an issue of overflowing content, this is added as a fix */
          "max-w-[-webkit-fill-available]",
        )}
        data-testid="recommendations_grid"
      >
        {recommendations?.map(recommendation => (
          <MemberCardWithConnection
            key={recommendation.target_community_member.id}
            member={recommendation.target_community_member}
          />
        ))}
      </ol>
    </div>
  );
};
